/* eslint-disable max-len */
/**
 * Spanish translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {
    CHALLENGE_DESCRIPTION: 'Descripción',
    END_DATE: 'Hasta',
    ID: 'Id.',
    OBJECTIVE: 'Objetivo',
    REWARD: 'Recompensa',
    START_DATE: 'El'
  },
  LABEL: {
    ACCUMULATED_VALUE: 'Importe acumulado',
    ACTIVES: 'Activos',
    AT: 'El',
    COUPON: 'Cupón',
    CREATED: 'Creado',
    DAY_VALUE: 'Importe del día',
    FAIL: 'Fallido',
    FINISHED: 'Completado',
    HISTORY: 'Historial',
    IN_PROGRESS: 'En curso',
    MONETARY_REWARD: 'Recompensa',
    NR_ACCESSES: 'Nuevos accesos',
    NR_NEW_CLIENTS: 'Nuevos clientes',
    NR_ORDERS: 'Pedidos',
    OBJECTIVE: 'Objetivo',
    OBJECTIVE_VALUE: 'Importe objetivo',
    OFFER: 'Premio',
    OPEN: 'Abrir',
    REMUNERATION: 'Remuneración',
    REWARD_TYPE: 'Tipo de recompensa',
    REWARD_TYPES: 'Tipos de recompensa',
    SALES: 'Ventas',
    SALES_BRANDS: 'Gamas a vender (€)',
    SALES_BRANDS_QTY: 'Gamas a vender (cant.)',
    SALES_CATEGORY: 'Categorías a vender (€)',
    SALES_CATEGORY_QTY: 'Categorías a vender (cant.)',
    SALES_COMMISSIONS: 'Comisiones de ventas',
    SALES_PRODUCTS: 'Productos a vender (€)',
    SALES_PRODUCTS_QTY: 'Productos a vender (cant.)',
    SUCCESS: 'Acción realizada correctamente',
    TO: '{0} a {1}',
    TODAY: 'Hoy'
  },
  SENTENCE: {
    CHALLANGES_DESCRIPTION: 'No hay desafíos activos (aún).',
    CHALLANGES_TITLE: 'No hay desafíos.'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
